import { combineReducers } from '@reduxjs/toolkit';

import metricLocalizationReducer from './metricLocalization/metricLocalizationSlice';
import liveViewReducer from './liveView/liveViewSlice';
import portalSettingsReducer from './portalSettings/slice';
import { metricLocalizationsApi } from './metricLocalization/api';
import { portalSettingsApi } from './portalSettings/api';

const appReducer = {
  metricLocalization: metricLocalizationReducer,
  liveView: liveViewReducer,
  portalSettings: portalSettingsReducer,
  [metricLocalizationsApi.reducerPath]: metricLocalizationsApi.reducer,
  [portalSettingsApi.reducerPath]: portalSettingsApi.reducer,
};


const appReducerState = combineReducers(appReducer);
export type RootState = ReturnType<typeof appReducerState>;
export default appReducer;
